// extracted by mini-css-extract-plugin
module.exports = {"curatedPages":"styles_curatedPages__Hl1pB"};